import React, { FC } from 'react';
import { Tooltip } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { INameObjectN } from '../../../../interfaces';
import { tF } from '../../../../translate';
import { LinkComponent } from '../../../../Components';
import TariffsStyles from '../../m_styles.less';

enum ItemStatus {
    CURRENT,
    NEW,
    OLD,
}

type IShowItem = {
    item?: INameObjectN;
    status: ItemStatus;
};
const ShowItem: FC<IShowItem> = ({ item, status }) => {
    if (!item?.id) {
        return null;
    }
    const { id, name } = item;
    return (
        <>
            {status === ItemStatus.NEW ? <ArrowDownOutlined className={TariffsStyles.icon} /> : null}
            <Tooltip
                title={tF(
                    status === ItemStatus.NEW
                        ? 'New tariff'
                        : status === ItemStatus.OLD
                        ? 'Old tariff'
                        : 'Current tariff',
                )}
            >
                <p
                    className={cx({
                        [TariffsStyles.new]: status === ItemStatus.NEW,
                        [TariffsStyles.old]: status === ItemStatus.OLD,
                    })}
                >
                    {`${
                        status === ItemStatus.NEW ? tF('New') + ': ' : status === ItemStatus.OLD ? tF('Old') + ': ' : ''
                    } `}
                    <span
                        className={cx({
                            [TariffsStyles.link]: status === ItemStatus.OLD,
                        })}
                    >
                        <LinkComponent currentListComponent={'TariffsList'} id={id} name={name} />
                    </span>
                </p>
            </Tooltip>
        </>
    );
};

type IShowUpdatedTariff = {
    currentTariff?: INameObjectN;
    isCurrentMonth?: boolean;
    selectedTariff?: INameObjectN;
};

export const ShowUpdatedTariff: FC<IShowUpdatedTariff> = ({
    currentTariff,
    isCurrentMonth,
    selectedTariff,
}: IShowUpdatedTariff) => {
    return (
        <div className={TariffsStyles.showUpdatedTariff}>
            {isCurrentMonth ? (
                currentTariff?.id ? (
                    <ShowItem status={ItemStatus.CURRENT} item={currentTariff} />
                ) : (
                    <ShowItem status={ItemStatus.NEW} item={selectedTariff} />
                )
            ) : (
                <>
                    {currentTariff?.id ? <ShowItem status={ItemStatus.OLD} item={currentTariff} /> : null}
                    <ShowItem status={ItemStatus.NEW} item={selectedTariff} />
                </>
            )}
        </div>
    );
};
